import { render } from "./MrateTypeCreate.vue?vue&type=template&id=5078c51e&scoped=true"
import script from "./MrateTypeCreate.vue?vue&type=script&lang=js"
export * from "./MrateTypeCreate.vue?vue&type=script&lang=js"

import "./MrateTypeCreate.vue?vue&type=style&index=0&id=5078c51e&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5078c51e"]])

export default __exports__